import type { LearningStoreGetters } from "@/store/learning/getters";
import type { LearningStoreState } from "@/store/learning/state";
import { LearningTaskModel } from "~~/package/mapper/learning/model/LearningTaskModel";
import { useLearningAssessmentStore } from "@/store/learning/assessment/learningAssessmentStore";

export const courseGetters = {
    taskList(state: LearningStoreState) {
        return state.course.chapterList
            .map(chapter => chapter.skillList)
            .flat()
            .map(skill => skill.taskList)
            .flat();
    },
    skillList(state: LearningStoreState) {
        return state.course.chapterList
            .map(chapter => chapter.skillList)
            .flat();
    },
    firstProSkillAssureTask(_state: LearningStoreState & LearningStoreGetters): LearningTaskModel {
        return useLearningAssessmentStore().firstProSkillAssureTask;
    },
    multipleChoiceAnswerList(state: LearningStoreState & LearningStoreGetters): number[] {
        return [...new Set(state.task.multipleChoiceQuestion.multipleChoiceResult.answerList)];
    }
};
